import React, { Component } from 'react';
import * as _ from 'lodash-es';
import CalciteModal from '../../shared/CalciteModal';
import parse from 'html-react-parser';
import CalciteDropdown from '../../shared/CalciteDropdown';
import PropTypes from 'prop-types';

class SubscriptionSelection extends Component {
	constructor(props) {
		super(props);

		const subscriptions = this.props.subscriptions;
		this.localizedKeys = this.props.localizedKeys;
		this.loadingTimeout = null;

		this.onChangeSelectedSubscriptions = this.onChangeSelectedSubscriptions.bind(this);
		this.handleCreateNewOrgClick = this.handleCreateNewOrgClick.bind(this);
		this.handleCreateNewOrgModalClose = this.handleCreateNewOrgModalClose.bind(this);
		this.handleDropdownBeforeOpen = this.handleDropdownBeforeOpen.bind(this);
		this.handleDropdownBeforeClose = this.handleDropdownBeforeClose.bind(this);

		this.state = {
			subscriptions: subscriptions,
			isNewOrgConfirmationModalOpen: false,
			disabled: false,
			loading: false,
		};
	}


	componentDidUpdate(prevProps) {
		const prevSelectedId = prevProps.selectedSubscriptions?.length ? prevProps.selectedSubscriptions[0]?.itemId : null;
		const currentSelectedId = this.props.selectedSubscriptions?.length ? this.props.selectedSubscriptions[0]?.itemId : null;
		if (prevSelectedId !== currentSelectedId) {
			if (this.state.loading) {
				this.setState({ loading: false });
			}
			clearTimeout(this.loadingTimeout);
		}
	}

	componentDidMount() {}

  componentWillUnmount() {
    clearTimeout(this.loadingTimeout);
  };

	onChangeSelectedSubscriptions(subscription) {
		if (this.props.selectedSubscriptions?.[0]?.itemId === subscription?.itemId) {
			return;
		}


		clearTimeout(this.loadingTimeout);
		// Set a new timeout to update the loading state after 600 milliseconds
		this.loadingTimeout = setTimeout(() => {
			this.setState({ loading: true });
		}, 600);
		this.props.onChangeSelectedSubscriptions([subscription]);
	}

	handleCreateNewOrgClick(newSubscriptionAvailable) {
		let selectedSubscription = this.props.selectedSubscriptions?.[0] || {};
		if (selectedSubscription.selectType === 'new') {
			return;
		}
		if (this.state.disabled) return;

		const hasLabels = this.localizedKeys.newOrgConfirmHeading && this.localizedKeys.newOrgConfirmMessage && this.localizedKeys.newOrgConfirmLabel;
		if (!hasLabels) {
			// Don't show confirmation modal if labels are not set
			this.handleCreateNewOrgModalConfirm(newSubscriptionAvailable);
		} else {
			this.setState({ isNewOrgConfirmationModalOpen: true });
		}
	}

	handleCreateNewOrgModalClose() {
		this.setState({ isNewOrgConfirmationModalOpen: false });
	}

	handleCreateNewOrgModalConfirm(newSubscriptionAvailable) {
		this.onChangeSelectedSubscriptions(newSubscriptionAvailable);
		this.setState({ isNewOrgConfirmationModalOpen: false });
	}

	handleDropdownBeforeOpen() {
		this.setState({ disabled: false });
	}

	handleDropdownBeforeClose() {
		this.setState({ disabled: true });
	}

	render() {
		let selectedSubscription = this.props.selectedSubscriptions?.[0] || {};
		let newSubscriptionAvailable = _.find(this.state.subscriptions, { selectType: 'new' }) || {};

		if (!_.isEmpty(selectedSubscription)) {
			selectedSubscription.title =
				selectedSubscription.selectType === 'new'
					? this.localizedKeys.newOrgTitle
					: selectedSubscription.subscriptionOrgURL
					? selectedSubscription.subscriptionOrgURL + ' : ' + selectedSubscription.subscriptionId
					: selectedSubscription.subscriptionId;
		}
		/*  const newOrg = <calcite-button scale="m" appearance="transparent" icon={plusCircle24F} icon-position="start" has-text={true} >
          {this.localizedKeys.newOrgLabel}
      </calcite-button> */

		const subscriptionSelector = this.state.subscriptions.map((subscription, index) => {
			if (subscription.selectType === 'new') return null;

			let subtypeName;
			if (subscription.selectType === 'existing') {
				subtypeName = this.localizedKeys.existingOrgLabel;
			} else if (subscription.selectType === 'renewal') {
				subtypeName = this.localizedKeys.renewOrgLabel;
			} else if (subscription.selectType === 'trial') {
				subtypeName = this.localizedKeys.convertTrialOrgLabel;
			}

			return (
				<calcite-dropdown-item
					key={index}
					hidden={this.state.disabled || undefined}
					selected={selectedSubscription.itemId === subscription.itemId || undefined}
					onClick={() => this.onChangeSelectedSubscriptions(subscription)}>
					{subscription.selectType !== 'new' && subscription.selectType !== 'existing' && (
						<p className="font-size--1 avenir-demi margin-bottom--1">{subtypeName}</p>
					)}
					<p className="font-size--1 margin-bottom--1">{subscription.subscriptionOrgURL ? subscription.subscriptionOrgURL : 'No org name'}</p>
					<p className="font-size--1 margin-bottom--1">{subscription.subscriptionId}</p>
				</calcite-dropdown-item>
			);
		});

		const hasError = this.props.proceedToCheckoutError && !selectedSubscription.itemId;

		return (
			<>
				{this.state.isNewOrgConfirmationModalOpen && (
					<CalciteModal
						className="subscription-modal"
						kind="brand"
						open={this.state.isNewOrgConfirmationModalOpen}
						onClose={this.handleCreateNewOrgModalClose}>
						<h3 slot="header" className="no-margin font-size-2">
							{this.localizedKeys.newOrgConfirmHeading}
						</h3>
						<div slot="content">{this.localizedKeys.newOrgConfirmMessage && parse(this.localizedKeys.newOrgConfirmMessage)}</div>
						<calcite-button slot="secondary" width="full" appearance="outline" onClick={this.handleCreateNewOrgModalClose}>
							{this.localizedKeys.cancelLabel}
						</calcite-button>
						<calcite-button slot="primary" width="full" onClick={() => this.handleCreateNewOrgModalConfirm(newSubscriptionAvailable)}>
							{this.localizedKeys.newOrgConfirmLabel}
						</calcite-button>
					</CalciteModal>
				)}
				<CalciteDropdown className="subscription-dropdown" onBeforeClose={this.handleDropdownBeforeClose} onBeforeOpen={this.handleDropdownBeforeOpen}>
					<calcite-button
						appearance="outline"
						kind={hasError ? 'danger' : 'brand'}
						alignment="icon-end-space-between"
						loading={this.state.loading || undefined}
						slot={'trigger'}
						width="full"
						icon-end={hasError ? 'exclamation-mark-triangle' : 'chevron-down'}>
						{selectedSubscription.title || this.localizedKeys.selectOrgLabel}
					</calcite-button>
					<calcite-dropdown-group group-title={this.localizedKeys.arcgisOnlineLabel} scale="m" selection-mode="single">
						{subscriptionSelector}
					</calcite-dropdown-group>
					{newSubscriptionAvailable.selectType === 'new' && (
						<calcite-dropdown-group scale="m" selection-mode="none">
								<calcite-dropdown-item onClick={() => this.handleCreateNewOrgClick(newSubscriptionAvailable)}>
									<calcite-link class="font-size-0 createOrgLink text-center" icon-start="plus-circle">
										{this.localizedKeys.newOrgLabel}
									</calcite-link>
								</calcite-dropdown-item>
						</calcite-dropdown-group>
					)}
				</CalciteDropdown>
			</>
		);
	}
}

SubscriptionSelection.propTypes = {
  subscriptions: PropTypes.array,
  selectedSubscriptions: PropTypes.array,
  proceedToCheckoutError: PropTypes.bool,
  onChangeSelectedSubscriptions: PropTypes.func,
};

export default SubscriptionSelection;

//
